import { NavLink, Link } from 'react-router-dom';
import { Key, Boxes, LayoutTemplate } from 'lucide-react';
import logo from '../../assets/logo.svg';

const navigation = [
  { name: 'Tokens', href: '/tokens', icon: Key },
  { name: 'Providers', href: '/providers', icon: Boxes },
  { name: 'Templates', href: '/templates', icon: LayoutTemplate },
];

export const Sidebar = () => {
  return (
    <aside className="bg-white border-r border-gray-200">
      {/* Logo Section */}
      <div className="mb-4 flex h-[49px] items-center justify-between border-b border-gray-200 pl-4">
        <div className="flex-1">
          <Link className="inline-block" to="/tokens">
            <img alt="Token Server" className="mt-1 h-6 transition-opacity hover:opacity-80" src={logo} />
          </Link>
        </div>
      </div>

      {/* Navigation */}
      <div className="flex w-64 flex-col gap-1 border-b border-gray-200 pb-4 pl-4">
        <nav className="space-y-1">
          {navigation.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                `group flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                  isActive
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <item.icon
                    className={`mr-3 flex-shrink-0 h-5 w-5 ${
                      isActive ? 'text-primary-600' : 'text-gray-500 group-hover:text-gray-700'
                    }`}
                  />
                  {item.name}
                </>
              )}
            </NavLink>
          ))}
        </nav>
      </div>
    </aside>
  );
};
